import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	statusMapping: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.status-mapping',
		defaultMessage: 'Status mapping',
		description: 'Label for status mapping',
	},
	statusMappingPlaceholder: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.status-mapping-placeholder',
		defaultMessage: 'Select or add a status',
		description: 'Placeholder message displayed for status mapping select dropdown',
	},
	statusMappingHelper: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.status-mapping-helper',
		defaultMessage: 'Start typing to search or add a custom status',
		description:
			'Helper text for status mapping that will be used in screen reader where user can start typing to search or add a custom status',
	},
	todo: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.todo',
		defaultMessage: 'To do',
		description: 'Label for to do status',
	},
	inprogress: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.inprogress',
		defaultMessage: 'In progress',
		description: 'Label for in progress status',
	},
	done: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.done',
		defaultMessage: 'Done',
		description: 'Label for done status',
	},
	addStatus: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status',
		defaultMessage: 'new status',
		description: 'Create label when adding a new status',
	},
});
